import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { OnboardingQuestion } from '@assetaccountant/core/models/onboarding/onboarding-question';
import { CreateOrganisationOnboardingQuestionsCommand } from '@assetaccountant/core/models/onboarding/onboarding-questions-command';
import { OnboardingService } from '@assetaccountant/core/services/onboarding.service';
import { TrackingService } from '@assetaccountant/core/services/tracking.service';
import { getOnboardingQuestions } from './question-config';

@Component({
  selector: 'app-onboarding-questions',
  templateUrl: './onboarding-questions.component.html',
  styleUrls: ['./onboarding-questions.component.scss'],
  standalone: false,
})
export class OnboardingQuestionsComponent implements OnInit {
  @Output() complete = new EventEmitter<null>();

  currentQuestionIndex = 0;
  onboardingQuestions: OnboardingQuestion[];

  get currentQuestion() {
    return this.onboardingQuestions[this.currentQuestionIndex];
  }

  get nextButtonLabel() {
    return this.currentQuestionIndex + 1 === this.onboardingQuestions?.length ? 'Finish' : 'Next';
  }

  constructor(
    private onboardingService: OnboardingService,
    private trackingService: TrackingService,
  ) {}

  ngOnInit() {
    this.trackingService.trackEvent('Onboarding questionare started');
    this.reset();
  }

  onBack() {
    if (this.currentQuestionIndex > 0) {
      this.currentQuestionIndex--;
    }
  }

  onNext() {
    if (this.currentQuestionIndex < this.onboardingQuestions.length - 1) {
      this.currentQuestionIndex++;
    } else {
      this.saveQuestion();
    }
  }

  reset() {
    this.onboardingQuestions = getOnboardingQuestions();
  }

  private getQuestion(name: string) {
    return this.onboardingQuestions.find(q => q.name === name);
  }

  private saveQuestion() {
    const command = {
      organisationType: this.getQuestion('organisationType')?.value,
      organisationRequirements: this.getQuestion('organisationRequirements')?.value,
    } as CreateOrganisationOnboardingQuestionsCommand;

    this.onboardingService.createOrganisationOnboardingQuestions(command).subscribe(() => {
      this.trackingService.trackEvent('Onboarding questionare completed', null, command);
      this.complete.emit();
    });
  }
}
